/** Renata menu ordered by business logic — Spanish labels only. */

import { BUSINESS_LEXICON } from "./lexicon.js";
import type { RenataFeatureId } from "@/lib/renata/copilot-features";

export interface RenataNavItem {
  to: string;
  label: string;
  group: "hoy" | "trabajo" | "conocimiento" | "equipo" | "ajustes";
  screenId: string;
  /** Si está definido, el ítem se oculta del nav cuando ese flag está deshabilitado. */
  featureFlag?: RenataFeatureId;
}

/** Business-first order (not architecture order). */
export const RENATA_NAV: RenataNavItem[] = [
  { to: "/app/renata/", label: BUSINESS_LEXICON.home, group: "hoy", screenId: "home" },
  { to: "/app/renata/chat", label: BUSINESS_LEXICON.chat, group: "hoy", screenId: "chat", featureFlag: "chat" },
  { to: "/app/customer-ai", label: BUSINESS_LEXICON.customerAi, group: "hoy", screenId: "customer-ai" },
  { to: "/app/renata/proveedores", label: BUSINESS_LEXICON.smartBuyer, group: "hoy", screenId: "supplier-ai", featureFlag: "smart_buyer" },
  { to: "/app/renata/insights", label: BUSINESS_LEXICON.insights, group: "hoy", screenId: "insights" },
  { to: "/app/renata/timeline", label: BUSINESS_LEXICON.timeline, group: "hoy", screenId: "timeline" },

  { to: "/app/renata/goals", label: BUSINESS_LEXICON.goals, group: "trabajo", screenId: "goals" },
  { to: "/app/renata/planning", label: BUSINESS_LEXICON.planning, group: "trabajo", screenId: "planning", featureFlag: "planning" },
  { to: "/app/renata/missions", label: BUSINESS_LEXICON.missions, group: "trabajo", screenId: "missions" },
  { to: "/app/renata/tasks", label: BUSINESS_LEXICON.tasks, group: "trabajo", screenId: "tasks" },
  { to: "/app/renata/playbooks", label: BUSINESS_LEXICON.playbooks, group: "trabajo", screenId: "playbooks" },
  { to: "/app/renata/push", label: BUSINESS_LEXICON.push, group: "trabajo", screenId: "push" },
  { to: "/app/renata/automatizaciones", label: BUSINESS_LEXICON.automations, group: "trabajo", screenId: "automations" },
  { to: "/app/renata/inbox", label: BUSINESS_LEXICON.inbox, group: "trabajo", screenId: "inbox", featureFlag: "inbox" },

  { to: "/app/renata/knowledge", label: BUSINESS_LEXICON.knowledge, group: "conocimiento", screenId: "knowledge", featureFlag: "knowledge" },
  { to: "/app/renata/learning", label: BUSINESS_LEXICON.learning, group: "conocimiento", screenId: "learning" },
  { to: "/app/renata/memory", label: BUSINESS_LEXICON.memory, group: "conocimiento", screenId: "memory" },

  { to: "/app/renata/handoff", label: BUSINESS_LEXICON.handoff, group: "equipo", screenId: "handoff" },
  { to: "/app/renata/agents", label: BUSINESS_LEXICON.agents, group: "equipo", screenId: "agents" },
  { to: "/app/renata/collaboration", label: BUSINESS_LEXICON.collaboration, group: "equipo", screenId: "collaboration" },

  { to: "/app/renata/packs", label: BUSINESS_LEXICON.packs, group: "ajustes", screenId: "packs" },
  { to: "/app/renata/store", label: BUSINESS_LEXICON.store, group: "ajustes", screenId: "store" },
  { to: "/app/renata/config", label: BUSINESS_LEXICON.config, group: "ajustes", screenId: "config" },
  { to: "/app/renata/usage", label: BUSINESS_LEXICON.usage, group: "ajustes", screenId: "usage" },
];

export const GROUP_LABELS: Record<RenataNavItem["group"], string> = {
  hoy: "Hoy",
  trabajo: "Trabajo",
  conocimiento: "Conocimiento del negocio",
  equipo: "Equipo",
  ajustes: "Ajustes",
};
